import { on, selectAll } from 'helpers/dom'

const selectors = {
  HEADER_ID: 'site-header',
  BUTTON_SELECTOR: '.js-scroll-button'
}

class ScrollButton extends HTMLElement {
  constructor () {
    super()
    this.scrollButton = selectAll(selectors.BUTTON_SELECTOR, this)
    this.isScroll()
  }

  isScroll() {
    this.scrollButton.forEach(button => {
      on(
        'click', (e) => {
          e.preventDefault()

          const targetId = button.getAttribute('data-href').replace(/#/g, '')
          const targetElement = document.getElementById(targetId)
          const headerHeight = document.getElementById('site-header').offsetHeight

          if (targetElement) {
            const targetPosition = targetElement.offsetTop - headerHeight

            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            })
          }
        },
        button
      )
    })
  }
}

if (!customElements.get('button-scroll')) {
  customElements.define('button-scroll', ScrollButton)
}
